import { render, staticRenderFns } from "./SingleParameter.vue?vue&type=template&id=3515f5d7&scoped=true&"
import script from "./SingleParameter.vue?vue&type=script&lang=js&"
export * from "./SingleParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3515f5d7",
  null
  
)

export default component.exports